export interface RequestContactByIdInterface {
  id: string;
}

export class ResponseContactInfoByIDInterface {
  id?: string;

  account_id?: string;

  contact_name?: string;

  country_id: string;

  country_of_passport: string;

  city_id: string;

  titlename: string;

  firstname: string;

  lastname: string;

  address_1: string;

  address_2: string;

  postcode: string;

  prefix_phone: string;

  phone_number: string;

  is_deleted?: number;

  status?: number;

  created_at?: string;

  updated_at?: string;

  email: string;

  sort: string;

  primary_contact: string;

  passport_number: string;

  passport_expiry_date: string;

  country_of_issued_passport: string;

  birthday: string;

  constructor(data: any) {
    this.id = data.id || "";
    this.account_id = data.account_id || "";
    this.contact_name = data.contact_name || "";
    this.country_id = data.country_id || "";
    this.country_of_passport = data.country_of_passport || "";
    this.city_id = data.city_id || "";
    this.titlename = data.titlename || "";
    this.firstname = data.firstname || "";
    this.lastname = data.lastname || "";
    this.address_1 = data.address_1 || "";
    this.address_2 = data.address_2 || "";
    this.postcode = data.postcode || "";
    this.prefix_phone = data.prefix_phone?.replace("+", "") || "";
    this.phone_number = data.phone_number || "";
    this.is_deleted = data.is_deleted || 0;
    this.status = data.status || 0;
    this.created_at = data.created_at || "";
    this.updated_at = data.updated_at || "";
    this.email = data.email || "";
    this.sort = data.sort || "";
    this.primary_contact = data.primary_contact || "";
    this.passport_number = data.passport_number || "";
    this.passport_expiry_date = data.passport_expiry_date || "";
    this.country_of_issued_passport = data.country_of_issued_passport || "";
    this.birthday = data.birthday || "";
  }
}
